import { useCallback, useState } from 'react';
import { fetchKoriBySourceStats } from '@/services/vastaanottoService';

export const useReservationSourceStats = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadStats = useCallback(async (alku, loppu) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchKoriBySourceStats(alku, loppu);
      setStats(response);
    }
    catch (err) {
      console.log(err);
      setError(err);
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { stats, loading, error, loadStats };
};
